module.exports    = {
	"package": {
		"name": "tauri",
		"version": "0.11.1",
		"authors": [
			"Lucas Fernandes Gonçalves Nogueira <lucas@tauri.studio>",
			"Daniel Thompson-Yvetot <denjell@sfosc.org>",
			"Tensor Programming <tensordeveloper@gmail.com>"
		],
		"categories": [
			"gui",
			"web-programming"
		],
		"license": "MIT",
		"homepage": "https://tauri.studio",
		"repository": "https://github.com/tauri-apps/tauri",
		"description": "Make tiny, secure apps for all desktop platforms with Tauri",
		"edition": "2018",
		"exclude": [
			"test/fixture/**"
		],
		"metadata": {
			"docs": {
				"rs": {
					"features": [
						"all-api"
					]
				}
			}
		}
	},
	"dependencies": {
		"serde_json": "1.0",
		"serde": {
			"version": "1.0",
			"features": [
				"derive"
			]
		},
		"webview_official": "0.0.4",
		"tauri_includedir": "0.6.0",
		"phf": "0.8.0",
		"base64": "0.13.0",
		"webbrowser": "0.5.5",
		"lazy_static": "1.4.0",
		"tiny_http": {
			"version": "0.7",
			"optional": true
		},
		"threadpool": "1.8",
		"uuid": {
			"version": "0.8.1",
			"features": [
				"v4"
			]
		},
		"anyhow": "1.0.37",
		"thiserror": "1.0.23",
		"envmnt": "0.8.4",
		"once_cell": "1.5.2",
		"tauri-api": {
			"version": "0.7.5",
			"path": "../tauri-api"
		},
		"urlencoding": "1.1.1"
	},
	"target": {
		"cfg(target_os = \"windows\")": {
			"dependencies": {
				"runas": "0.2"
			}
		}
	},
	"build-dependencies": {
		"tauri_includedir_codegen": "0.6.2",
		"cfg_aliases": "0.1.1"
	},
	"dev-dependencies": {
		"proptest": "0.10.1",
		"serde_json": "1.0",
		"tauri": {
			"path": ".",
			"features": [
				"all-api"
			]
		},
		"serde": {
			"version": "1.0",
			"features": [
				"derive"
			]
		}
	},
	"features": {
		"cli": [
			"tauri-api/cli"
		],
		"embedded-server": [
			"tiny_http"
		],
		"no-server": [],
		"all-api": [
			"tauri-api/notification"
		],
		"read-text-file": [],
		"read-binary-file": [],
		"write-file": [],
		"write-binary-file": [],
		"read-dir": [],
		"copy-file": [],
		"create-dir": [],
		"remove-dir": [],
		"remove-file": [],
		"rename-file": [],
		"path-api": [],
		"set-title": [],
		"execute": [],
		"open": [],
		"event": [],
		"updater": [],
		"open-dialog": [],
		"save-dialog": [],
		"http-request": [],
		"notification": [
			"tauri-api/notification"
		]
	},
	"example": [
		{
			"name": "communication",
			"path": "examples/communication/src-tauri/src/main.rs"
		}
	]
}